<template>
  <AccountingPage title="Achats">
    <PurchaseForAccountingTable/>
  </AccountingPage>
</template>

<script>
import AccountingPage from "@/accounting/components/AccountingPage.vue";
import PurchaseForAccountingTable from "@/accounting/components/tables/PurchaseForAccountingTable.vue";

export default {
  name: 'AccountingPurchaseView',
  components: {
    PurchaseForAccountingTable,
    AccountingPage,
  },
}
</script>
